import React from 'react';
import { Box, Typography, Card, CardContent, useMediaQuery, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { CountryData } from '../../Services/apiResponseInterfaces';
import useTranslation from '../Language/useTranslation';

interface PieChartCustomProps {
    countryInfo: CountryData;
}

export default function PieChartCustom({ countryInfo }: PieChartCustomProps) {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery('(min-width:1600px)');
    const t = useTranslation();
    const data = countryInfo.restoration_measure_pie_chart ? countryInfo.restoration_measure_pie_chart.labels.map((label, index) => ({
        name: label,
        value: countryInfo?.restoration_measure_pie_chart?.areas_in_ha[index],
        color: countryInfo?.restoration_measure_pie_chart?.colors[index],
    })) : [];

    return (
        <Box>
            <Card>
                <CardContent>
                    <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        gutterBottom
                    >
                        {t.rightMainDrawer.chartTitle}
                    </Typography>
                    <ResponsiveContainer width="100%" height={130}>
                        <PieChart>
                            <Pie
                                data={data}
                                cx={isLargeScreen ? "40%" : "50%"} // Zentriert, wenn der Bildschirm kleiner als 1600px ist
                                cy="50%"
                                labelLine={false}
                                outerRadius={60}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value: number) => `${value} ha`} />
                            {isLargeScreen && (
                                <Legend
                                    layout="vertical"
                                    align="right"
                                    verticalAlign="middle"
                                    wrapperStyle={{ fontSize: '12px', maxWidth: '220px', paddingLeft: '-50px' }}
                                    content={({ payload }) => (
                                        <div style={{ maxHeight: '150px', overflowY: 'auto', paddingRight: '10px' }}>
                                            {payload?.map((entry, index) => (

                                                <div key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', whiteSpace: 'nowrap' }}>
                                                    <div style={{
                                                        minWidth: '12px',
                                                        height: '12px',
                                                        backgroundColor: entry.color,
                                                        borderRadius: '50%',
                                                        marginRight: '8px'
                                                    }}></div>
                                                    <span style={{ color: entry.color }}>
                                                        {entry.value.length > 30 ? `${entry.value.substring(0, 30)}...` : entry.value}
                                                    </span>

                                                </div>
                                            ))}
                                        </div>
                                    )}
                                />
                            )}
                        </PieChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </Box>
    );
}


